import React from 'react'
import { observer } from 'mobx-react-lite'

import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'

import { useBudgetsStore } from '../../../common'
import { SubBudgetCategory } from '../shared/SubBudgetCategory'
import { type DetailedBudget } from '../../../core'

interface SubBudgetRowProps {
  budget: DetailedBudget
}

export const SubBudgetRow: React.FC<SubBudgetRowProps> = observer(({ budget }) => {
  const { setSelectedSubBudget } = useBudgetsStore()

  return (
    <ListItem>
      <ListItemButton onClick={() => setSelectedSubBudget(budget)}>
        <SubBudgetCategory budget={budget} />
      </ListItemButton>
    </ListItem>
  )
})
